import { withChartLayout } from 'components/common';
import PCAFlowsheet from 'components/features/chart/special-charts/pca-flowsheet/PCAFlowsheet';

const PCAFlowsheetPage = withChartLayout('PCA Flowsheet')(PCAFlowsheet);
export default PCAFlowsheetPage;
